/** Sole salon location for public booking queries. */
export const LOCATION_ID = 'rodeonails-main';
